export default __webpack_public_path__ + "static/angroid-header-a2fa041b4ce975a577ac5f90036131eb.jpg";